import React from 'react';

const Pesca = () => {
  return (
<div className="container mt-5 pt-3">
      {/* Section 1: Bootstrap Carousel */}
      <div id="senderismoCarousel" className="carousel slide mb-5" data-bs-ride="carousel">
        <div className="carousel-indicators">
          <button type="button" data-bs-target="#senderismoCarousel" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
          <button type="button" data-bs-target="#senderismoCarousel" data-bs-slide-to="1" aria-label="Slide 2"></button>
          <button type="button" data-bs-target="#senderismoCarousel" data-bs-slide-to="2" aria-label="Slide 3"></button>
        </div>
        
        <div className="carousel-inner rounded shadow">
          <div className="carousel-item active">
            <img src="/pesca.jpg" className="d-block w-100" alt="Eco Cabaña" style={{ maxHeight: '600px', width: '100%', objectFit: 'contain' }} />
          </div>
          <div className="carousel-item">
            <img src="/pesca2.jpg" className="d-block w-100" alt="Sendero forestal" style={{ maxHeight: '600px', width: '100%', objectFit: 'contain' }} />
          </div>
          <div className="carousel-item">
            <img src="/sec3_pesca.jpg" className="d-block w-100" alt="Vista panorámica" style={{ maxHeight: '600px', width: '100%', objectFit: 'contain' }} />
          </div>
        </div>
        
        <button className="carousel-control-prev" type="button" data-bs-target="#senderismoCarousel" data-bs-slide="prev">
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button className="carousel-control-next" type="button" data-bs-target="#senderismoCarousel" data-bs-slide="next">
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
      
      {/* Section 2: Title and Description */}
      <div className="row">
        <div className="col-12 text-center">
          <h1 className="display-4 text-success mb-3">Pesca</h1>
          <p className="lead mb-5 text-start">En Casa Origen Ecohotel nos enorgullece ofrecer experiencias auténticas y sostenibles que conectan a nuestros huéspedes con la naturaleza de una manera única. La pesca es una de nuestras actividades más destacadas, diseñada para aquellos que buscan disfrutar de la tranquilidad y belleza de nuestros paisajes, mientras participan en una práctica que respeta el ecosistema local.
          <br/>Proveemos todos los equipos necesarios para la pesca, asegurándonos de que se lleve a cabo de manera responsable, sin afectar a la fauna acuática. Además, nuestros guías locales brindan información sobre las mejores técnicas y el respeto por las especies autóctonas. </p>
        </div>
      </div>
    </div>
  );
};

export default Pesca;